import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import clsx from 'clsx';
type Option = {
	id: string;
	value: string;
	label: string;
};

type RadioSize = 'sm' | 'md';
interface Props {
	value?: string | undefined;
	options: Option[];
	defaultValue?: string;
	classNameLabel?: string;
	disabled?: boolean;
	orientation?: 'horizontal' | 'vertical';
	size?: RadioSize;
	classNameContainer?: string;
	className?: string;
	readonly?: boolean;
	onChange: (value: string) => void;
}

export const RadioButton: React.FC<Props> = ({
	orientation = 'horizontal',
	defaultValue,
	disabled,
	options,
	size = 'md',
	value,
	className,
	classNameContainer,
	classNameLabel,
	readonly,
	onChange,
}) => {
	const sizeClasses = {
		sm: 'h-4 w-4',
		md: 'h-6 w-6',
	};

	return (
		<RadioGroup
			value={value}
			defaultValue={defaultValue}
			onValueChange={onChange}
			orientation={orientation}
			className={clsx(
				'',
				{
					'flex flex-col': orientation === 'vertical',
					'pointer-events-none': readonly,
				},
				className
			)}
			disabled={disabled}
		>
			{options.map(({ id, value, label }, index) => (
				<div
					key={index}
					className={clsx(
						'flex items-center space-x-2 mb-2 last:!mb-0',
						classNameContainer
					)}
				>
					<RadioGroupItem
						value={value}
						id={id}
						size={size}
						className={clsx(
							'bg-gradient-to-b from-[#FFFFFF] to-[#F4F4F9] border-opacity-primary',
							sizeClasses[size]
						)}
					/>
					<label
						htmlFor={value}
						className={clsx('text-black text-base', classNameLabel)}
					>
						{label}
					</label>
				</div>
			))}
		</RadioGroup>
	);
};
